import {Slide, ThemeProvider} from "@mui/material";
import {modalTheme} from "../../theme/theme";
import BasicModal from "../../Modal/BasicModal";
import CloseIcon from "@mui/icons-material/Close";
import {currencyConverter} from "../../../utility/methods";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {useDispatch} from "react-redux";
import {selectedVehicleType} from "../../../slices/vehicleSlice";
import CompareButton from "./CompareButton";

const TrimModal = ({
                       open, handleClose, checked, vehicleImage, modelName, modelYear, defaultType,
                       showSelector, vehiclesTrim, vehicleTypeName, trimVehicle, compareTrim, activeLocal, trimType,
                       selectedVehicleCode, setSelectedVehicleCode, vehicleCode, setVehicleCode
                   }) => {

    const dispatch = useDispatch();
    const handleVehicleSelect = (vehicleCode, vehicleMedia, vehicle) => {
        dispatch(selectedVehicleType(trimVehicle));
        setSelectedVehicleCode(prevCode => prevCode === vehicleCode ? null : vehicleCode);
        setVehicleCode(prevCode =>
            prevCode && prevCode.code === vehicleCode ? {} : {code: vehicleCode, media: vehicleMedia, vehicle: vehicle}
        );
    };

    return (
        <ThemeProvider theme={modalTheme}>
            <div className={"modal-wrapper"}>
                <BasicModal
                    open={open}
                    onClose={handleClose}
                    disableScrollLock={true}
                    role={'dialog'}
                    style={{overflow: 'auto'}}
                >
                    <Slide
                        direction={'down'}
                        in={checked}
                        style={{transformOrigin: '50% 50% 0'}}
                        {...(checked ? {timeout: 1000} : {})}>

                        <div className='select-trim-overlay'>
                            <div className='trim-modal-container'>
                                <button type='button' className={'close'} onClick={handleClose}>
                                    <CloseIcon fontSize={"small"}/>
                                </button>
                                <div className={'figure-image'}>
                                    <img src={vehicleImage} alt={modelName}/>
                                </div>
                                <div className={'model-year'}>{modelYear} {modelName} </div>
                                <div className={'trim-row'}>
                                    {
                                        defaultType.VEHICLE_TYPE_NAME && defaultType.VEHICLE_TYPE.length > 1 ? showSelector() : null
                                    }
                                </div>
                                <div className={'trim-overlay'}>
                                    {
                                        vehiclesTrim.filter((vehicle) => vehicle.features[vehicleTypeName] === trimVehicle).map((vehicle) => (
                                            <div className='trim-row'
                                                 key={vehicle.code}
                                                 id="vehicle-select-radio"
                                                 onClick={() => handleVehicleSelect(vehicle.code, vehicle?.media, vehicle)}>
                                                <div className={'custom-control'}>
                                                    <input
                                                        type="radio"
                                                        name={'vehicles'}
                                                        className={`radio-button ${selectedVehicleCode === vehicle.code ? 'hidden' : ''}`}

                                                    />
                                                    {selectedVehicleCode === vehicle.code && (
                                                        <CheckCircleIcon className={'advantage-icon'}
                                                                         fontSize={'small'}/>
                                                    )}
                                                    <div className="trim-name">{vehicle.trim}</div>
                                                </div>
                                                <div className={'trim-price'}>
                                                    {currencyConverter(vehicle.pricing[Object.keys(vehicle.pricing)[0]], activeLocal)}
                                                </div>
                                                <div className="variation-name">{vehicle.variation}</div>
                                            </div>
                                        ))
                                    }
                                </div>

                                <CompareButton vehicleCode={vehicleCode}
                                               compareTrim={compareTrim}
                                               trimType={trimType}
                                               vehiclesTrim = {vehiclesTrim}/>

                            </div>

                        </div>

                    </Slide>


                </BasicModal>
            </div>
        </ThemeProvider>
    );
};

export default TrimModal;